import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureException } from '@sentry/react-router';

import { type OutrightsCouponIndexProps, OutrightsCouponWithQuery } from '@cx-modules/outrights-coupon';

export const OutrightsCoupon = (props: Omit<OutrightsCouponIndexProps, 'i18n'>) => {
  const { i18n } = useTranslation();

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureException(error);
        return null;
      }}
    >
      <OutrightsCouponWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
